import { api } from './api-client';
import type { MyClustersResponse } from '@livinhome/shared';

export async function getMyClusters(): Promise<MyClustersResponse> {
  const { data } = await api.get<MyClustersResponse>('/admin/my-clusters');
  return data;
}

export async function switchCluster(cluster_id: string): Promise<void> {
  await api.post('/admin/switch-cluster/clerk', { cluster_id });
}
